/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Feature/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Feature({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Apps/Content/App/LearnMore/Content/Feature"
  
}) {
let constantData = '•'
let featureDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'feature',
path: 'description',
})
let aggregateData = fromAggregate.join(constantData, featureDescriptionValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 data="'•'"
 data="feature.description"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}